import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Button } from '../../components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';

function StatusBadge({ status }) {
  const styles = {
    paid: 'bg-emerald-100 text-emerald-800',
    pending: 'bg-amber-100 text-amber-800',
    failed: 'bg-red-100 text-red-800',
    cancelled: 'bg-slate-100 text-slate-700',
    cash_on_delivery: 'bg-blue-100 text-blue-800',
    whatsapp_order: 'bg-violet-100 text-violet-800',
    completed: 'bg-emerald-100 text-emerald-800',
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium ${styles[status] || 'bg-slate-100 text-slate-700'}`}>
      {status || '-'}
    </span>
  );
}

export default function AdminStoreOrders() {
  const [data, setData] = useState([]);
  const [status, setStatus] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [userId, setUserId] = useState('');
  const [storeId, setStoreId] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/admin/store-orders', {
      params: {
        status: status || undefined,
        payment_method: paymentMethod || undefined,
        user_id: userId || undefined,
        store_id: storeId || undefined,
        date_from: dateFrom || undefined,
        date_to: dateTo || undefined,
      },
    }).then(r => setData(r.data.orders || [])).catch(() => {});
  }, [status, paymentMethod, userId, storeId, dateFrom, dateTo]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900 tracking-tight" style={{ fontFamily: 'Outfit' }}>Store Orders</h1>
        <p className="text-slate-500 text-sm mt-0.5">Orders will appear here when store checkout is enabled.</p>
      </div>
      <Card className="bg-white border border-slate-200 shadow-sm rounded-2xl">
        <CardHeader>
          <CardTitle className="text-lg" style={{ fontFamily: 'Outfit' }}>Orders</CardTitle>
          <div className="flex flex-wrap gap-3 mt-3">
            <Select value={status || 'all'} onValueChange={(value) => setStatus(value === 'all' ? '' : value)}>
              <SelectTrigger className="w-44"><SelectValue placeholder="Status" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All statuses</SelectItem>
                <SelectItem value="pending">Pending</SelectItem>
                <SelectItem value="paid">Paid</SelectItem>
                <SelectItem value="failed">Failed</SelectItem>
                <SelectItem value="cancelled">Cancelled</SelectItem>
                <SelectItem value="cash_on_delivery">Cash on delivery</SelectItem>
                <SelectItem value="whatsapp_order">WhatsApp order</SelectItem>
                <SelectItem value="completed">Completed</SelectItem>
              </SelectContent>
            </Select>
            <Select value={paymentMethod || 'all'} onValueChange={(value) => setPaymentMethod(value === 'all' ? '' : value)}>
              <SelectTrigger className="w-52"><SelectValue placeholder="Payment method" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All methods</SelectItem>
                <SelectItem value="online_payment">Online payment</SelectItem>
                <SelectItem value="whatsapp_order">WhatsApp order</SelectItem>
                <SelectItem value="cash_on_delivery">Cash on delivery</SelectItem>
              </SelectContent>
            </Select>
            <Input className="w-56" placeholder="User ID" value={userId} onChange={(e) => setUserId(e.target.value)} />
            <Input className="w-56" placeholder="Store ID" value={storeId} onChange={(e) => setStoreId(e.target.value)} />
            <Input className="w-48" type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
            <Input className="w-48" type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
          </div>
        </CardHeader>
        <CardContent className="overflow-x-auto">
          <Table>
              <TableHeader>
              <TableRow>
                <TableHead>Order #</TableHead>
                <TableHead>Customer</TableHead>
                <TableHead>Store</TableHead>
                <TableHead>Product</TableHead>
                <TableHead>Total</TableHead>
                <TableHead>Method</TableHead>
                <TableHead>Gateway</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>User</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
              <TableBody>
              {data.map(order => (
                <TableRow key={order.id || order._id}>
                  <TableCell className="font-mono text-xs">{order.order_number || order.reference_code || '-'}</TableCell>
                  <TableCell>{order.customer_name || '-'}</TableCell>
                  <TableCell>{order.store_name || order.store_id || '-'}</TableCell>
                  <TableCell>{order.product_name || '-'}</TableCell>
                  <TableCell>{order.currency || 'UGX'} {Number(order.total_amount || order.amount || 0).toLocaleString()}</TableCell>
                  <TableCell>{order.payment_method || '-'}</TableCell>
                  <TableCell>{order.gateway || '-'}</TableCell>
                  <TableCell><StatusBadge status={order.status} /></TableCell>
                  <TableCell>{order.user_id || '-'}</TableCell>
                  <TableCell>
                    <Button variant="outline" size="sm" onClick={() => navigate(`/admin/store-orders/${order.id || order._id}`)}>View</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
